module.exports = __webpack_public_path__ + "static/section-5-img-1-825d1db1f7edf66e5656d01c8b1f14a3.png";